<template>
  <div class="main">
    <div class="left-bar">
      <sub-left-menu :menus="menus" :selectTrace="selectTrace"></sub-left-menu>
    </div>
    <div class="sub-main">
      <breadcrumb :paths="selectTrace"></breadcrumb>
      <div class="product-list">
        <div class="product-item" v-for="(product,index) in products" :key="index">
          <div class="product-item-image" @click="toDetail(product.productId)">
            <img :src="'http://image.teamcorp.cn/wo_de/product/' + product.image" alt="">
          </div>
          <div class="product-item-info">
            <div class="product-item-title" @click="toDetail(product.productId)">{{product.name}}</div>
            <div class="product-item-brief">{{product.info}}</div>
            <div class="product-item-href" @click="toDetail(product.productId)">了解详情</div>
          </div>
        </div>
      </div>
      <div class="load-more" @click="loadMore" v-if="!productEmpty && products.length > 0">加载更多...</div>
      <div class="load-more" v-if="productEmpty && products.length > 0">已无更多内容</div>
      <div class="load-more" v-if="productEmpty && products.length == 0">暂无该内产品</div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/widgets/public/Breadcrumb'
import SubLeftMenu from '@/widgets/public/SubLeftMenu'
import service from '@/utils/service'
import tools from '@/utils/base'

export default {
  components: { Breadcrumb, SubLeftMenu },
  data () {
    return {
      classifyTree: [],
      currentNode: [],
      products: [],
      classifyId: 0,
      search: '',
      productEmpty: false
    }
  },
  created () {
    this.refreshProductInfo()
  },
  computed: {
    menus () {
      let menus = []
      for (var i in this.classifyTree) {
        let node = this.toMenuItem(this.classifyTree[i])
        if ('children' in this.classifyTree[i]) {
          let menuItem = []
          for (var j in this.classifyTree[i]['children']) {
            menuItem.push(this.toMenuItem(this.classifyTree[i]['children'][j]))
          }
          node['children'] = menuItem
        }
        menus.push(node)
      }
      return menus
    },
    selectTrace () {
      let selectTrace = []
      for (var i in this.currentNode) {
        selectTrace.push(this.toMenuItem(this.currentNode[i]))
      }
      return selectTrace
    }
  },
  methods: {
    refreshProductInfo () {
      this.classifyId = tools.getIndex(this.$route.query, 'classifyId', 0)
      this.search = tools.getIndex(this.$route.query, 'search', '')
      this.products = []
      this.productEmpty = false
      this.loadPathTrace()
      this.loadMenu()
      this.loadProducts(0)
    },
    loadMenu () {
      let _this = this
      service.get('/product/classifyTree').then(function (response) {
        for (let i in response) {
          if (_this.hasClassify(response[i], _this.classifyId)) {
            _this.classifyTree = response[i].children
            return true
          }
        }
      })
    },
    hasClassify (tree, id) {
      if (parseInt(tree['nodeId']) === parseInt(id)) {
        return true
      }
      if ('children' in tree) {
        for (let i in tree['children']) {
          if (this.hasClassify(tree['children'][i], id)) {
            return true
          }
        }
      }
      return false
    },
    loadPathTrace () {
      if (this.search.length > 0) {
        this.currentNode = [{nodeId: 0, label: '搜索'}]
      } else if (this.classifyId > 0) {
        let _this = this
        service.get('/product/getTrace?nodeId=' + this.classifyId).then(function (response) {
          _this.currentNode = response
        })
      }
    },
    loadProducts (offset) {
      let _this = this
      service.get('/product/search?classifyId=' + this.classifyId + '&search=' + this.search + '&offset=' + offset).then(function (response) {
        _this.products = _this.products.concat(response)
        if (response.length < 10) {
          _this.productEmpty = true
        }
      })
    },
    toDetail (productId) {
      this.$router.push('/product/' + productId)
    },
    toMenuItem (node) {
      return {'nodeId': node.nodeId, 'name': node.label, 'url': '/product?classifyId=' + node.nodeId}
    },
    loadMore () {
      let offset = this.products.length
      this.loadProducts(offset)
    }
  },
  watch: {
    $route () {
      this.refreshProductInfo()
    }
  }
}
</script>

<style scoped>
.product-list {
  margin-top: 15px;
}
.product-item {
  margin-bottom: 22px;
  background: #ffffff;
  display: flex;
  height: 180px;
  overflow: hidden;
  border-top:solid 1px #dee6ee;
}
.product-item-image {
  width: 240px;
  height: 180px;
  overflow:hidden;
  background: #ffffff;
  text-align: center;
    cursor: pointer;
}
.product-item-info {
  flex: 1;
   padding: 14px 19px 14px 19px;
  display: flex;
  flex-direction: column;
}
.product-item-title {
    color: #333333;
  font-size: 19px;
  margin-bottom: 4px;
    cursor: pointer;
}
.product-item-title:hover{
color: #018FD7;
}
.product-item-brief {
  flex: 1;
}
.product-item-href {
  /* padding: 2px 0; */
  cursor: pointer;
}
.product-item-href:hover{
    color:#018FD7;
}
.load-more{
  margin: 25px 0 0 0;
  cursor: pointer;
  color:#018FD7;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/product/List.vue